import styles from './index.module.less';
import YoutubeIcon from '../../../assets/youtube.svg?react';
import InsIcon from '../../../assets/instagram.svg?react';
import TikTokIcon from '../../../assets/tiktok.svg?react';
import LinkedinIcon from '../../../assets/linkedin.svg?react';
import ShareBtnIcon from '../../../assets/link-to.svg?react';
import DefaultAvatarIcon from '../../../assets/profile.svg?react';
import FJImage from '@src/common/components/FJImage/FJImage.tsx';
import FJUtil from '@src/util/FJUtil';
import { useAppDispatch } from '@src/redux/hooks.ts';
import { FJDetailsPageAction } from '@src/redux/action/FJDetailsPageAction.ts';

const platformIcons = {
    youtube: <YoutubeIcon />,
    instagram: <InsIcon />,
    tiktok: <TikTokIcon />,
    linkedin: <LinkedinIcon />,
};

interface Props {
    avatarUrl: string;
    name: string;
    time: string;
    shareType: string;
    shareUrl: string;
}

const FJHistoryItem = ({ avatarUrl, name, time, shareType, shareUrl }: Props) => {
    const dispatch = useAppDispatch();

    const onClick = () => {
        dispatch(FJDetailsPageAction.openLinkAction(shareUrl, shareType, time));
    };

    return (
        <div className={styles.accountItem}>
            <div className={styles.left}>
                <div className={styles.avatar_box}>
                    {avatarUrl ? (
                        <FJImage
                            imgSrc={avatarUrl}
                            imgClassName={styles.avatar}
                            boxClassName={styles.avatar_box}
                            disableDefaultImgClass
                            alt=''
                        />
                    ) : (
                        <DefaultAvatarIcon />
                    )}
                    <div className={styles.platformIcon}>{platformIcons[shareType as keyof typeof platformIcons]}</div>
                </div>
                <p className={styles.name}>{name}</p>
            </div>
            <div className={styles.right}>
                <p className={styles.time}>{FJUtil.formatIsoTimestamp(time)}</p>
                <div className={styles.btn} onClick={onClick}>
                    <ShareBtnIcon />
                </div>
            </div>
        </div>
    );
};

export default FJHistoryItem;
